import {ProductionCategoryDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_CUSTOMER_CATEGORY';

export async function createProductionCategory(
    userData: Record<string, string>,
    productionCategory: Record<string, any>
) {
    try {
        const result = await ProductionCategoryDao.createProductionCategory(userData.userToken, productionCategory);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
